import { SVGProps } from '@utils';
import React, { FC } from 'react';
import { SvgWrapper } from './SvgWrapper';

interface SearchProps extends SVGProps {
  hexFill?: string;
  size?: number;
}

export const Search: FC<SearchProps> = ({ onClick, divClassName, hexFill, size }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size ?? "16"} 
      height={size ?? "16"} 
      viewBox="0 0 16 15" 
      fill="none"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M7.18604 0.925903C10.7923 0.925903 13.7158 3.75455 13.7158 7.24385C13.7158 8.73543 13.1816 10.1063 12.2882 11.1871L14.9544 13.7674C15.2377 14.0416 15.2377 14.486 14.9544 14.7602C14.6928 15.0132 14.2813 15.0327 13.9967 14.8186L13.9283 14.7602L11.2615 12.1805C10.1445 13.0449 8.72763 13.5618 7.18604 13.5618C3.57974 13.5618 0.65625 10.7332 0.65625 7.24385C0.65625 3.75455 3.57974 0.925903 7.18604 0.925903ZM7.18644 2.32991C4.38154 2.32991 2.10772 4.52996 2.10772 7.24387C2.10772 9.95777 4.38154 12.1578 7.18644 12.1578C9.99134 12.1578 12.2652 9.95777 12.2652 7.24387C12.2652 4.52996 9.99134 2.32991 7.18644 2.32991Z" 
        fill={hexFill ?? "#64748B"} 
        fillOpacity="0.7" 
      />
    </svg>
  </SvgWrapper>
);
